import gql from 'graphql-tag';

export const RelationsForContentQuery =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query RelationsForContentQuery(
			$relationName: String!
			$sourceType: String!
			$targetKey: String!
			$targetStatus: String!
		) @experimental {
			experimentalRelationsForContent(
				relationName: $relationName
				sourceType: $sourceType
				targetKey: $targetKey
				targetStatus: $targetStatus
			) {
				results {
					source {
						displayName
						accountId
						profilePicture {
							path
						}
					}
					relationData {
						friendlyCreatedDate
					}
				}
			}
		}
	`;
